import { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/css/Wraper.css";
import Footer from "./Pages/Footer/Footer";
import Section2 from "./Pages/Herosection/Herosection";
import Navbar from "./Pages/Navbar/Navbar";
import AndarBahar from "./games/AndarBahar/AndarBaharGames";
import AvailableGames from "./games/AvailableGames/AvailableGames";
import StartLine from "./games/StarLine/StartLine";
import ContactUs from "./Pages/ContactUs/ContactUs";
import FandQSection from "./Pages/FandQSection/FandQSection";
import Section4 from "./Pages/MainSection/Section4";
import GameRateSection from "./Pages/GameRates/GameRateSection";
import { useLocation } from "react-router-dom";
import { Download } from "lucide-react";
import { downloadAPK } from "./Helpers/DownloadAPK";


const Wraper = () => {
  const location = useLocation();

const download = async (e) => {
  e.preventDefault();

  const newTab = window.open("about:blank", "_blank");

  if (!newTab) {
    alert("Popup blocked! Please allow popups.");
    return;
  }

  // Only favicon loader (tab ke upar spinner)
  const loaderIcon =
    "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'><circle cx='50' cy='50' r='40' stroke='%23999' stroke-width='8' fill='none' stroke-dasharray='180'><animateTransform attributeName='transform' type='rotate' from='0 50 50' to='360 50 50' dur='1s' repeatCount='indefinite'/></circle></svg>";

  try {
    // Empty page
    newTab.document.open();
    newTab.document.write("<html><head></head><body></body></html>");
    newTab.document.close();

    // Set favicon (THIS IS YOUR “EARTH ICON LOADER”)
    const link = newTab.document.createElement("link");
    link.rel = "icon";
    link.href = loaderIcon;
    newTab.document.head.appendChild(link);

    newTab.document.title = "Loading...";

    const url = await downloadAPK();

    if (!url) {
      newTab.close();
      return;
    }

    // start download (no redirect flicker)
    const a = document.createElement("a");
    a.href = url;
    a.download = "boss555.apk";
    document.body.appendChild(a);
    a.click();
    a.remove();

    setTimeout(() => {
      newTab.close();
    }, 1500);
  } catch (err) {
    newTab.close();
    console.error(err);
  }
};
  

  useEffect(() => {
    if (location.state?.scrollTo) {
      const el = document.getElementById(location.state.scrollTo);
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);

  return (
    <>
      <Navbar />
      <Section2 />
      {/* <Section3 /> */}
      <GameRateSection />
      <AvailableGames />
      <StartLine />
      <AndarBahar />
      <Section4 />
      {/* <FandQSection />
      <ContactUs /> */}
      <Footer />

      {/* Animation Styles */}
      <style>{`
        .liquid-wave {
          position: absolute;
          top: 0;
          left: -100%;
          width: 200%;
          height: 100%;
          background: linear-gradient(
            120deg,
            rgba(255,255,255,0) 30%,
            rgba(255,255,255,0.4) 50%,
            rgba(255,255,255,0) 70%
          );
          transform: skewX(-25deg);
          animation: liquidFlow 3s infinite;
          z-index: 0;
          pointer-events: none;
        }
        @keyframes liquidFlow {
          0% { transform: translateX(-100%) skewX(-25deg); }
          100% { transform: translateX(100%) skewX(-25deg); }
        }
      `}</style>

      {/* 100% Tailwind Responsive Button */}
      <button
        onClick={download}
        className="tw-fixed tw-bottom-8 tw-z-50 tw-overflow-hidden
                   /* CENTER LOGIC: Pure Tailwind */
                   tw-left-1/2 tw--translate-x-1/2
                   
                   /* STYLING */
                   tw-bg-gradient-to-r tw-from-blue-600 tw-via-blue-700 tw-to-blue-800 
                   tw-text-white tw-font-bold tw-rounded-full
                   tw-shadow-[0_15px_35px_rgba(0,0,0,0.4)]
                   tw-flex tw-items-center tw-justify-center
                   tw-transition-all tw-duration-300 
                   hover:tw-scale-[1.02] active:tw-scale-95
                   
                   /* WIDTH LOGIC (10/12 columns on Desktop) */
                   tw-w-[365px]               /* Mobile: Small */
                   sm:tw-w-[450px]            /* Tablet: Medium */
                   lg:tw-w-[83.33%]           /* Desktop: 10/12 (approx 83%) */
                   tw-w-[1200px]          /* Limit for Ultra-wide screens */
                   
                   /* PADDING */
                   tw-py-4 sm:tw-py-6"
      >
        <span className="liquid-wave"></span>

        <span
          className="tw-relative tw-z-10 tw-flex tw-items-center tw-gap-3 
                         tw-text-base sm:tw-text-xl lg:tw-text-2xl tw-whitespace-nowrap tw-tracking-wider"
        >
          DOWNLOAD
          <Download className="tw-w-5 tw-h-5 sm:tw-w-8 sm:tw-h-8 tw-animate-bounce" />
        </span>
      </button>
    </>
  );
};

export default Wraper;
